import { getBackendToken } from "./authUtils";

export async function apiFetch(url, options = {}) {
  const token = await getBackendToken();

  const headers = {
    ...(options.headers || {}),
    Authorization: `Bearer ${token}`,
  };

  return fetch(url, { ...options, headers });
}